import React from 'react'

export default function Markets({ data }) {
    return (
        <>
            <li><a href="?">{data.title} <em>{data.sub_title}</em></a></li>
        </>
    )
}
